import { logger } from "@/infrastructure/services/LoggerService";
/**
 * Minimal analytics-tracking composable. No backend exists yet for this event stream — every call
 * is logged via the app's `LoggerService` (dev-only, no-op in production, see `LoggerService`)
 * until a real sink is wired in.
 */
export function useAnalyticsTracker() {
    function track(event, payload) {
        logger.debug(`[analytics] ${event}`, payload);
    }
    return { track };
}
